{
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {},
      "geometry": {
        "coordinates": [
          [
            [
              -79.21167029384021,
              26.92562342198319
            ],
            [
              -78.5728415233917,
              24.47719664083276
            ],
            [
              -77.52840718440474,
              23.42076274382076
            ],
            [
              -74.009778877331,
              21.92377096306491
            ],
            [
              -72.44819743845727,
              22.25262738259333
            ],
            [
              -74.20244152238718,
              24.26475547530424
            ],
            [
              -76.98083966687739,
              27.25062496315094
            ],
            [
              -79.21167029384021,
              26.92562342198319
            ]
          ]
        ],
        "type": "Polygon"
      }
    }
  ]
}